"use client";

import * as React from "react";
import { Input as BaseInput } from "@unreserved/ui/components/input";
import { cn } from "@unreserved/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  className?: string;
}

export function Input({ className, ...props }: InputProps) {
  return (
    <BaseInput
      className={cn(className, "bg-white!")}
      {...props}
    />
  );
}

